import React from 'react';

import Link from '../Link/Link';
import DocIcon from '../../../../public/images/svg/Document-Icon.svg';

type Props = {
  onClick: Function,
  name: string,
  url: string,
  dataId: number,
  index: number,
};

function InfoDocument(props: Props) {
  const { name, url, dataId, index, onClick } = props;
  return (
    <div
      data-automation-id={`infoGuidesDoc-${dataId}-${index}`}
      className="u__normal"
      key={name}
    >
      <img
        className="u--paddingXsmall-right"
        src={DocIcon}
        alt="document"
        data-automation-id={`infoGuidesImg-${dataId}-${index}`}
      />
      <Link target="_blank" href={url} content={name} onClick={onClick} />
    </div>
  );
}

export default InfoDocument;
